/**
 * iter649 — Extracted from MenuItemsPage.jsx (was inside the edit
 * Sheet, lines ~1158-1201). The suggested-price banner pops up when
 * the user deep-links from POS Performance overlay's "Suggest new
 * price" button. Pure presentational; the parent owns banner state
 * and the apply/dismiss handlers.
 */
import React from 'react';
import { Button } from '@/components/ui/button';

export function SuggestedPriceBanner({ banner, onApply, onDismiss }) {
  if (!banner) return null;
  return (
    <div
      className="rounded-xl bg-rose-50 dark:bg-rose-950/20 border border-rose-200 dark:border-rose-900 p-3 mb-4 flex items-start gap-3"
      data-testid="suggested-price-banner"
    >
      <div className="text-rose-600 mt-0.5">⚠️</div>
      <div className="flex-1">
        <p className="text-sm font-semibold text-rose-800 dark:text-rose-300">
          Pricing alert: <span className="font-bold">{banner.itemName}</span> is losing money.
        </p>
        <p className="text-xs text-rose-700/80 dark:text-rose-400/80 mt-0.5">
          Current price <span className="font-semibold">{banner.currentPrice}</span> · cost{' '}
          <span className="font-semibold">{banner.cost}</span> · suggested minimum{' '}
          <span className="font-bold text-emerald-700">{banner.suggestedPrice.toFixed(2)}</span>{' '}
          (cost × 1.3 = 30% margin).
        </p>
      </div>
      <Button
        size="sm"
        onClick={onApply}
        className="bg-emerald-600 hover:bg-emerald-700 text-white text-xs"
        data-testid="suggested-price-apply"
      >
        Apply suggested price
      </Button>
      <Button
        size="sm"
        variant="ghost"
        onClick={onDismiss}
        className="text-rose-600 hover:bg-rose-100 h-8 w-8 p-0"
        data-testid="suggested-price-dismiss"
        title="Dismiss"
      >
        ×
      </Button>
    </div>
  );
}
